import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { SharedModalsMap } from './SharedModalsMap';
// ⚠️ Bump uniqueGlobalKey (e.g. v2 → v3) AND version whenever SharedModalsMap gains or loses keys.
// getPremiumSingleton returns a cached singleton from window — stale bundles won't reinitialize
// on version mismatch, only log a warning. A key change is the only reliable bust.
export const DomainsSharedModalsExtension = ModuleExtensions.modalsExtension(SharedModalsMap, {
    sdkName: 'domainsModals',
    version: 2,
    uniqueGlobalKey: 'domainsSharedModals-v2',
});
//# sourceMappingURL=sharedModals.extension.js.map